/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import {FETCH_PORTFOLIO_CONTENTS_REQUEST, FETCH_PORTFOLIO_CONTENTS_SUCCESS, FETCH_PORTFOLIO_CONTENTS_FAILURE} from './PortfolioContentsType';

 const initialState = {
    loading: false,
    error: "",
    portfolioContentDetails:{
    }
  };
  
  const portfolioContentDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PORTFOLIO_CONTENTS_REQUEST:
        return {
          ...state,
          loading: true,
        };
  
      case FETCH_PORTFOLIO_CONTENTS_SUCCESS:
        return {
          loading: false,
          portfolioContentDetails: action.payload,
          error: "",
        };
      case FETCH_PORTFOLIO_CONTENTS_FAILURE:
        return {
          loading: false,
          portfolioContentDetails: {},
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default portfolioContentDetailsReducer;
  
